module.exports = __webpack_public_path__ + "img/iconPaper.8ca8a9bd.svg";